import React from 'react';
import { Link } from 'react-router-dom';
import { FiLinkedin, FiMail, FiTwitter } from 'react-icons/fi';
import { NAV_LINKS, SITE_METADATA, PERSONAL_INFO, SOCIAL_LINKS } from '../utils/constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy text-white">
      <div className="container-custom px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-2xl font-serif text-white mb-3">Anu Singh</h3>
            <p className="text-gray-300 mb-1">Co-Founder &amp; CEO, Zakool AI | Author</p>
            <p className="text-gray-400 text-sm">{PERSONAL_INFO.tagline}</p>
            <div className="flex space-x-4 mt-5">
              <a href={SITE_METADATA.linkedIn} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-gold" aria-label="LinkedIn"><FiLinkedin size={20} /></a>
              {SOCIAL_LINKS.twitter && <a href={SOCIAL_LINKS.twitter} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-gold" aria-label="X / Twitter"><FiTwitter size={20} /></a>}
              <a href={`mailto:${SITE_METADATA.email}`} className="text-gray-300 hover:text-gold" aria-label="Email"><FiMail size={20} /></a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-4">Explore</h4>
            <ul className="space-y-2">
              {NAV_LINKS.map((link) => (
                <li key={link.name}><Link to={link.path} className="text-gray-300 hover:text-gold">{link.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-4">Connect</h4>
            <a href={`mailto:${SITE_METADATA.email}`} className="text-gray-300 hover:text-gold block mb-2">{SITE_METADATA.email}</a>
            <a href="https://zakool.ai" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-gold">zakool.ai</a>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-7">
          <p className="text-gray-400 text-sm">© {currentYear} Anu Singh. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
